<template>
  <div>
    <LeaveClassModal
      ref="leaveClassModal"
      modal-title="转班前，原学生离班日期设置"
      :classroom-id="classroomId"
      :should-reconfirm="true"
      @leaveSuccess="changeClassStepTwo"
    ></LeaveClassModal>
    <!-- 学生转班组件 -->
    <ChangeClassDrawerNew
      ref="changeClassDrawer"
      :school-id="schoolId"
      :rel-classroom-id="relClassroomId"
      :classroom-id="classroomId"
      :cache-year-terms="cacheYearTerms"
      @refreshData="refreshData"
    ></ChangeClassDrawerNew>
  </div>
</template>
<script>
import LeaveClassModal from './LeaveClassModal.vue';
import ChangeClassDrawerNew from './ChangeClassDrawerNew.vue';
export default {
  components: {
    LeaveClassModal,
    ChangeClassDrawerNew
  },
  props: {
    classroomId: {
      type: String,
      default: ''
    }, // 课班id
    relClassroomId: {
      type: String,
      default: ''
    }, // 商品id
    schoolId: {
      type: String,
      default: ''
    }, // 学校id
    cacheYearTerms: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    // 转班的第一步，先对选择的学生进行离班操作
    changeClassStepOne(selectStudentData) {
      if (selectStudentData.length > 100) {
        this.$Message.error('单次操作学生人数不得大于100人');
        return false;
      }
      this.$nextTick(() => {
        this.$refs.leaveClassModal.openLeaveModal(selectStudentData);
      });
    },
    // 转班的第二步，对已离班学生进行入班操作
    changeClassStepTwo(selectStudentData) {
      this.$emit('refreshList');
      console.log(selectStudentData, '选择的数据==liban====');
      const dataObj = {};
      selectStudentData.forEach(item => {
        dataObj[item.payOrderId] = item;
      });
      this.$nextTick(() => {
        this.$refs.changeClassDrawer.openDrawer(dataObj);
      });
    },
    refreshData() {
      this.$emit('refreshList');
    }
  }

};
</script>
<style lang="scss" scoped>

</style>
